const SET_ADMINS = 'SET_ADMINS';
const SET_ADMINS_REFACTORED = 'SET_ADMINS_REFACTORED';
const SET_SELECTED_ADMIN = 'SET_SELECTED_ADMIN';

export { SET_ADMINS, SET_ADMINS_REFACTORED, SET_SELECTED_ADMIN };
